import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {  Admin_Region_Name } from '../../../../constants';
import { Box, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';

const RegionFilters = ({
  search,
  setSearch,
  selectedRegion,
  setSelectedRegion,
}) => {
  const [regions, setRegions] = useState([]);

  useEffect(() => {
    const fetchRegions = async () => {
      try {
        const response = await axios.get(`${Admin_Region_Name}`);
        if (response.data.success) {
          setRegions(response.data.data);
        }
      } catch (error) {
        console.error('Failed to fetch regions', error);
      }
    };
    fetchRegions();
  }, []);

  return (
    // <div>
    //   <input
    //     type="text"
    //     value={search}
    //     onChange={e => setSearch(e.target.value)}
    //     placeholder="Search regions"
    //   />
    //   <select
    //     value={selectedRegion}
    //     onChange={e => setSelectedRegion(e.target.value)}
    //   >
    //     <option value="">All Regions</option>
    //     {regions.map(region => (
    //       <option key={region.RegionId} value={region.RegionId}>
    //         {region.RegionName}
    //       </option>
    //     ))}
    //   </select>
    // </div>
    <Box display="flex" gap={2} alignItems="center">
      <TextField
        type="text"
        value={search}
        onChange={e => setSearch(e.target.value)}
        placeholder="Search "
        label="Search by ID or Name"
        variant="outlined"
        size="small"
      />
      <FormControl variant="outlined" size="small" sx={{ minWidth: 180 }}>
        <InputLabel id="region-select-label">Region</InputLabel>
        <Select
          labelId="region-select-label"
          value={selectedRegion}
          label="Region"
          onChange={e => setSelectedRegion(e.target.value)}
        >
          <MenuItem value="">
            <em>All Regions</em>
          </MenuItem>
          {regions.map(region => (
            <MenuItem key={region.RegionId} value={region.RegionId}>
              {region.RegionName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default RegionFilters;
